import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import logoFcamara from '../../assets/imgs/logo-fcamara.svg';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  footer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      marginBottom: 16,
    },
  },
  copyright: {
    fontSize: 12.8,
    color: theme.palette.neutrals.low.medium,
  },
  logo: {
    marginRight: 10,
    [theme.breakpoints.down('md')]: {
      width: 69,
    },
  },
}));
function FooterAuthentication() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Box className={classes.footer}>
        <Box className={classes.logo}>
        <img src={logoFcamara} alt="logo fcamara" style={{ width: '100%' }} />
        </Box>
        <Box className={classes.copyright}>
        Imagine {t('inovacao')} &copy; {new Date().getFullYear()}
        </Box>
      </Box>
    </>
  );
}

export { FooterAuthentication };
